// src/views/Operaciones/LiquidacionClientes/EliminarLiquidacionSemanas.jsx
import React, { useEffect, useState } from "react";
import apiRoutes from "../../../api/apiRoutes";
import { apiFetchJson, appFetchJson } from "../../../utils/http";
import BtnGuardar from "../../../components/buttons/BtnGuardar";
import BtnCancelar from "../../../components/buttons/BtnCancelar";

/**
 * Props:
 * - id: ID de la liquidación a eliminar
 * - onVolver / onClose: cerrar modal
 * - onEliminado: callback al eliminar OK
 */
export default function EliminarLiquidacionSemanas({
  id,
  onVolver,
  onClose,
  onEliminado,
}) {
  const closeFn = onClose || onVolver || (() => {});
  const eliminadoFn = onEliminado || (() => {});

  const [loading, setLoading] = useState(true);
  const [removing, setRemoving] = useState(false);
  const [error, setError] = useState("");
  const [d, setD] = useState(null);

  // ============================
  //        CARGA INICIAL
  // ============================
  useEffect(() => {
    if (!id) return;

    const load = async () => {
      setLoading(true);
      setError("");

      try {
        const dto = await apiFetchJson(
          apiRoutes.liquidacion.detail(id)
        );
        setD(dto);
      } catch (e) {
        setError(e?.message || "Error al cargar la liquidación");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [id]);

  // ============================
  //        ELIMINAR
  // ============================
  const handleEliminar = async () => {
    if (!id) return;

    setRemoving(true);
    setError("");

    try {
      await appFetchJson(
        apiRoutes.liquidacion.delete(id),
        { method: "DELETE" }
      );

      await Promise.resolve(eliminadoFn());
      closeFn();
    } catch (e) {
      const status = e?.status ?? e?.response?.status;

      if (status === 404) {
        setError("La liquidación no existe o ya fue eliminada.");
      } else if (status === 403) {
        setError("No tiene permiso para eliminar esta liquidación.");
      } else if (status === 409) {
        setError(e?.message || "No se puede eliminar la liquidación (en uso).");
      } else {
        setError(e?.message || "No se pudo eliminar la liquidación.");
      }
      setRemoving(false);
    }
  };

  // ============================
  //        RENDER
  // ============================
  if (loading) {
    return (
      <div className="modal-backdrop">
        <div className="modal-panel-lg">
          <div className="modal-body">Cargando…</div>
        </div>
      </div>
    );
  }

  return (
    <div className="modal-backdrop" onClick={closeFn}>
      <div className="modal-panel-lg" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="modal-header">
          <h2 className="section-title text-red-700">
            Eliminar Liquidación
          </h2>
        </div>

        {/* Body */}
        <div className="modal-body space-y-4">
          {error && (
            <div className="rounded border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-800">
              {error}
            </div>
          )}

          <div className="rounded border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-800">
            ¿Está seguro que desea eliminar esta liquidación?
          </div>

          <div className="text-center">
            <span className="font-semibold">Descripción:</span>{" "}
            <span className="text-gray-800">
              {d?.descripcion ?? "—"}
            </span>
          </div>
        </div>

        {/* Footer */}
        <div className="modal-footer">
          <div className="btn-row">
            <BtnGuardar
              label={removing ? "Eliminando…" : "Eliminar"}
              saving={removing}
              isValid={!removing}
              className="bg-red-600 hover:bg-red-700 text-white"
              onClick={handleEliminar}
            />
            <BtnCancelar onClick={closeFn} />
          </div>
        </div>
      </div>
    </div>
  );
}
